<div>
    <c-input type="text" model-property="value" model-validation="validation" model-focus="toggleMenu(true)"></c-input><i ng-click="toggleMenu()" class="combo-angle fa fa-angle-down"></i>
</div>
<div ng-if="showMenu" class="options">
    <ul>
        <li ng-repeat="item in options track by $index">{{ item }}</li>
    </ul>
</div>
